<section class="mt-2">
  <div class="mx-auto max-w-2xl">
    @if (isLoading()) {
      <p class="text-sm text-text-muted">Loading numeron details...</p>
    } @else if (!canDelete()) {
      <article
        class="overflow-hidden rounded-lg bg-white shadow-xl shadow-black/10 ring-1 ring-black/5"
      >
        <header class="border-b border-subtle bg-surface px-6 py-4">
          <h1 class="m-0 text-xl font-semibold leading-tight text-text">Delete Numeron</h1>
        </header>

        <div class="px-6 py-5">
          <p class="text-sm text-danger">{{ loadErrorMessage() }}</p>
        </div>

        <footer class="border-t border-subtle bg-surface px-6 py-4">
          <a
            class="inline-flex items-center justify-center rounded-lg border border-subtle bg-white px-4 py-2 text-sm font-medium text-text transition duration-200 ease-in-out hover:bg-surface"
            [routerLink]="cancelHref"
          >
            Back
          </a>
        </footer>
      </article>
    } @else {
      <article
        class="overflow-hidden rounded-lg bg-white shadow-xl shadow-black/10 ring-1 ring-black/5"
      >
        <header class="border-b border-subtle bg-surface px-6 py-4">
          <h1 class="m-0 text-xl font-semibold leading-tight text-text">Delete Numeron</h1>
        </header>

        <div class="grid gap-4 px-6 py-5">
          <p class="text-sm text-text">
            Are you sure you want to permanently delete
            <span class="font-semibold text-text">{{ numeronTitle() }}</span
            >?
          </p>
          <p class="text-sm text-text-muted">
            This action cannot be undone and will permanently remove the Numeron.
          </p>

          @if (deleteErrorMessage()) {
            <p class="text-sm text-danger">{{ deleteErrorMessage() }}</p>
          }
        </div>

        <footer class="border-t border-subtle bg-surface px-6 py-4">
          <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
            <button
              type="button"
              class="inline-flex items-center justify-center rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white transition duration-200 ease-in-out hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-200 disabled:cursor-not-allowed disabled:opacity-60"
              [disabled]="isDeleting()"
              (click)="deleteNumeron()"
            >
              {{ isDeleting() ? 'Deleting...' : 'Delete Numeron' }}
            </button>

            <a
              class="inline-flex items-center justify-center rounded-lg border border-subtle bg-white px-4 py-2 text-sm font-medium text-text transition duration-200 ease-in-out hover:bg-surface"
              [routerLink]="cancelHref"
            >
              Cancel
            </a>
          </div>
        </footer>
      </article>
    }
  </div>
</section>
